import { Provider } from '@angular/core';

import { Capacitor } from '@capacitor/core';

import { PushNotificationsPlatformNativeService } from '@core/services/push-notifications/platforms/push-notifications-platform-native.service';
import { PushNotificationsPlatformWebFcmService } from '@core/services/push-notifications/platforms/push-notifications-platform-web-fcm.service';
import { PushNotificationsPlatformService } from '@core/services/push-notifications/platforms/push-notifications-platform.service';
import { PushNotificationsService } from '@core/services/push-notifications/push-notifications.service';

import { PushNotificationsApiService } from './push-notifications-api.service';

export function providePushNotifications(): Provider {
  const factory = () => {
    const isNative = Capacitor.isNativePlatform();

    if (isNative) {
      return new PushNotificationsPlatformNativeService();
    }
    return new PushNotificationsPlatformWebFcmService();
  };

  return [
    PushNotificationsService,
    PushNotificationsApiService,
    {
      provide: PushNotificationsPlatformService,
      useFactory: factory
    }
  ];
}
